import * as React from 'react';
import { useRef, useState } from 'react';
import styled from 'styled-components';
import downarrow from 'mainpage/knowledgebase/img/down-arrow.svg';
import useOutsideClick from 'hooks/useOutsideClick';
import { KV } from 'models/IfKV';
import { ListItem } from './ListItem';
import icon_more from '../imgs/icon_more.svg';
import { usePopNewDoc } from '../docgrp/PopNewDoc';
import { getDocGrpByDocType } from '../common/docwriteutil';
import { useZstdDocWrite } from '../common/useZstdDocWrite';
import { DOC_TYPE } from 'definitions/DocType';
import { countrylang } from 'util/langutil';
import { CopyItem, usePopCopyDocItem } from '../docgrp/PopCopyDocItem';
import { useCopyDoc } from '../docgrp/useCopyDoc';

/**
 * 문서 복제 처리 방안 검토.
 * 1. 문서를 복제할 때, 새로운 탭을 띄워서 새글쓰기를 표시한다.
 * 2. 복제된 문서의 전달은, sessionStorage를 이용한다.
 *   - 전달한것가 받은 것이 일치하는지 확인하기 위하여, uuid 를 사용하여 체크한다.
 *   - session storage 에 copydoc 키에, uuid, doc 를설정하며, uuid는 querystring으로도 전달한다.
 *   - 수신완료 후에는, 키를 제거한다.
 * 3. 파일 복제의 경우, 서버측에서, 참조수를 관리하는 방식으로 처리한다.
 */

type Props = {
  kvs: KV<string, string>[];
  width?: string;
  sels: KV<string, string>[];
  onChange: (e: KV<string, string>) => void;
};
export const DropDownBtn = ({ kvs, width, sels, onChange }: Props) => {
  const [showList, setShowList] = useState(false);
  const handleClick = () => {
    setShowList(!showList);
  };

  const ref = useRef();
  const refBtn = useRef();

  useOutsideClick(
    [ref, refBtn],
    () => {
      setShowList(false);
    },
    []
  );

  const { inputDoc } = useZstdDocWrite();

  const [popNewDoc, PopNewDoc] = usePopNewDoc();
  const [popCopyDocItem, PopCopyDocItem] = usePopCopyDocItem();

  const { makeDoc } = useCopyDoc();

  const handleClickCopy = (toLang: string) => {
    // popCopyDocItem.current.show().then(res => {
    //   console.log("copydocitem res", res, "toLang", toLang);
    //   const items: CopyItem[] = res?.items;
    //   // 각 선택된 항목을 복제하여 새로운 팝업으로 띄울 것.
    //   // 형식은.
    //   // {copyid : uuid, doc: savedoc }
    //   makeDoc({toLang}).then(res => {
    //     console.log("makeDoc res", res);
    //     window.open(countrylang(`/community/new/0?copyid=${res.copyid}`), '_blank');
    //   });

    // });
    // 각 선택된 항목을 복제하여 새로운 팝업으로 띄울 것.
    // 형식은.
    // {copyid : uuid, doc: savedoc }

    // 바로 카피하도록. 선택하는것 제거. (시간 가능할때 추가. )
    makeDoc({ toLang }).then((res) => {
      console.log('makeDoc res', res);
      window.open(countrylang(`/community/new/0?copyid=${res.copyid}`), '_blank');
    });
  };

  return (
    <Body>
      <Btn onClick={handleClick} ref={refBtn}>
        <img src={icon_more} />
      </Btn>
      {showList && (
        <List ref={ref} style={{ width }}>
          {kvs.map((ele) => (
            <ListItem
              key={ele.key}
              kv={ele}
              onClick={() => {
                setShowList(false);
                onChange(ele);
                if (ele.key === 'cmd-new' || ele.key === 'cmd-copy') {
                  popNewDoc.current.show({ cmd: ele.key, lang: inputDoc.exposeSiteLanguage }).then((res) => {
                    console.log('res', res, 'ele', ele);
                    // fromLang, toLang,
                    if (ele.key === 'cmd-new') {
                      const docgrp = getDocGrpByDocType(inputDoc.docType as DOC_TYPE);
                      window.open(countrylang(`/community/new/0?docgrp=${docgrp}&lang=${res.toLang}`), '_blank');
                    } else if (ele.key === 'cmd-copy') {
                      console.log('cmd-copy', ele);
                      handleClickCopy(res.toLang);
                    }
                  });
                }
              }}
              sel={!!sels.find((e) => e.key === ele.key)}
            />
          ))}
        </List>
      )}
      <PopNewDoc />
      <PopCopyDocItem />
    </Body>
  );
};

const List = styled.div`
  min-width: 10rem;
  min-height: 10rem;
  position: absolute;
  top: 4rem;
  right: 0;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  background-color: white;
  z-index: 2;
  font-size: 1.4rem;
  border-radius: 0.8rem;
  border: 1px solid #e5e5e5;
  display: flex;
  flex-direction: column;
  padding: 0.1rem;
  text-align: center;
`;

const Btn = styled.button`
  margin-left: 0.4rem;
  background-color: white;
  height: 3.5rem;
  width: 3.5rem;
  border-radius: 2rem;
  cursor: pointer;
  position: relative;
  & img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`;

const Body = styled.div`
  width: fit-content;
  padding: 0.4rem;
  position: relative;
`;
